import { Col, Container, Row } from 'reactstrap';
import {
  FooterContainer,
  FooterLink,
  FooterLinkImage,
  FooterLogo,
  FooterTitle,
} from './styled';

export default function Footer() {
  return (
    <FooterContainer>
      <Container>
        <Row style={{ alignItems: 'center' }}>
          <Col md={{ size: 5 }}>
            <FooterLogo />
          </Col>
          <Col md={{ size: 7 }}>
            <Row style={{ alignItems: 'center' }}>
              <Col md={{ size: 6 }}>
                <FooterTitle>Nos siga nas redes</FooterTitle>
                <FooterLink>
                  <FooterLinkImage src={'/icons/insta.svg'} />
                  Instagram
                </FooterLink>
                <FooterLink>
                  <FooterLinkImage src={'/icons/face.svg'} />
                  Facebook
                </FooterLink>
              </Col>
              <Col>
                <FooterTitle>Criado por Evon Safetech</FooterTitle>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </FooterContainer>
  );
}
